export default "__VITE_ASSET__MOKOl7mOPJYpSTW2nyk4zA__"